import { createFileRoute } from '@tanstack/react-router'

import { PlatformToolsPage as ToolsPage } from '../../../components/pages/backoffice/platform/platform-tools-page/platform-tools-page.tsx'

export const Route = createFileRoute('/bo/tools/')({
  component: ToolsPage,
})
